export const getSessionStorageData = (key: string) => {
  let value = ''
  if (typeof window !== 'undefined') {
    try {
      value = sessionStorage.getItem(key) || ''
    } catch {
      // Storage blocked in private browsing / WebViews
    }
  }
  return value
}

export const setSessionStorageData = (key: string, value: string) => {
  if (typeof window !== 'undefined') {
    try {
      sessionStorage.setItem(key, value)
    } catch {
      // Storage blocked in private browsing / WebViews
    }
  }
}

export const removeSessionStorageData = (key: string) => {
  if (typeof window !== 'undefined') {
    try {
      sessionStorage.removeItem(key)
    } catch {
      // Storage blocked in private browsing / WebViews
    }
  }
}